// Breaks the circular dependency:
// store → reducers/root → reducers/login → actions/login → auth → store
//
// Neither auth.js nor store.js imports the other anymore.
// store.js calls setStoreRef() after creating the store.
// auth.js calls getStoreRef() inside functions (never at module evaluation time).

let _store = null

export function setStoreRef(store) {
  _store = store
}

export function getStoreRef() {
  return _store
}
